<template>
  <div
    :class="{'my-navbar': true, 'no-fixed': noFixed}"
    v-infinite-scroll="loadMore"
    infinite-scroll-disabled="scrollDisabled"
    infinite-scroll-immediate-check="false">
    <mt-navbar v-model="selected">
      <mt-tab-item
        v-for="(item, index) in tabTitle"
        :key="index"
        :id="index">{{item}}
      </mt-tab-item>
    </mt-navbar>
    <!-- tab-container -->
    <mt-tab-container v-model="selected">
      <mt-tab-container-item
        v-for="(item, index) in tabTitle"
        :key="index"
        :id="index">
          <slot :name="`tab-cnt${index}`"></slot>
      </mt-tab-container-item>
    </mt-tab-container>
    <slot name="nav-bottom"></slot>
  </div>
</template>

<script>
export default {
  data () {
    return {
      selected: 0
    }
  },
  props: {
    tabTitle: {
      type: Array,
      require: true,
      default: () => []
    },
    currentTabIndex: {
      type: Number,
      default: 0
    },
    scrollDisabled: {
      type: Boolean,
      default: false
    },
    noFixed: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    loadMore () {
      this.$emit('loadMore')
    }
  },
  watch: {
    selected () {
      this.$emit('tabChange', this.selected)
    },
    currentTabIndex () {
      this.selected = this.currentTabIndex
    }
  }
}
</script>

<style scoped>
  .my-navbar{
    font-size: 12px;
  }
  .my-navbar .mint-navbar{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
  }
  .my-navbar .mint-tab-item.is-selected{
    border-bottom: 3px solid #dd4c4f;
    color: #dd4c4f;
  }
  .my-navbar >>> .mint-tab-item-label{
    font-size: 14px;
  }
  .my-navbar .mint-tab-container{
    padding-top: 51px;
    background: #fff;
  }
  .my-navbar.no-fixed .mint-navbar{
    position: relative;
    width: 100%;
    box-sizing: border-box;
  }
  .my-navbar.no-fixed .mint-tab-container{
    padding-top: 3px;
  }
</style>
